<template>
    <div>
        <div class="max-w-md mx-auto p-6 bg-white rounded-xl shadow-md">
            <div class="space-y-4">
                <div>
                    <label for="type-abonnement" class="block text-sm font-medium text-gray-700 mb-2">
                        Type d'abonnement
                    </label>
                    <select 
                        id="type-abonnement"
                        v-model="societe.type_abonnement"
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                    >
                        <option value="trial">Essai gratuit</option>
                        <option value="monthly">Abonnement mensuel</option>
                        <option value="yearly">Abonnement annuel</option>
                    </select>
                </div>

                <div class="flex items-center gap-2">
                    <input 
                        type="checkbox" 
                        id="auto-reminders" 
                        v-model="societe.auto_reminders" 
                        class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <label for="auto-reminders" class="block text-sm font-medium text-gray-700">
                        Possède les relances automatiques
                    </label>
                </div>

                <div class="flex items-center gap-2">
                    <input 
                        type="checkbox" 
                        id="client-portal" 
                        v-model="societe.client_portal" 
                        class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <label for="client-portal" class="block text-sm font-medium text-gray-700">
                        Possède le portail client
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            societe: {
                type_abonnement: 'trial'
            }
        }
    },
}
</script>

<style lang="scss" scoped>

</style>